import React, { useEffect, useRef } from "react";

export default function JitsiMeeting({ roomName, displayName, onApiReady, height = "70vh" }) {
  const containerRef = useRef(null);
  const apiRef = useRef(null);

  useEffect(() => {
    const domain = process.env.REACT_APP_JITSI_DOMAIN || "meet.jit.si";

    const loadScript = () =>
      new Promise((resolve, reject) => {
        if (window.JitsiMeetExternalAPI) return resolve();
        const s = document.createElement("script");
        s.src = `https://${domain}/external_api.js`;
        s.async = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error("Jitsi script failed to load"));
        document.body.appendChild(s);
      });

    let mounted = true;
    loadScript()
      .then(() => {
        if (!mounted || !containerRef.current) return;
        const api = new window.JitsiMeetExternalAPI(domain, {
          roomName,
          parentNode: containerRef.current,
          width: "100%",
          height: "100%",
          userInfo: { displayName: displayName || "Guest" },
          configOverwrite: {
            prejoinPageEnabled: false,
            disableDeepLinking: true,
            startWithAudioMuted: true,
            startWithVideoMuted: false,
          },
          interfaceConfigOverwrite: {
            DEFAULT_BACKGROUND: "#050505",
            DISABLE_VIDEO_BACKGROUND: false,
            SHOW_JITSI_WATERMARK: false,
            SHOW_WATERMARK_FOR_GUESTS: false,
          },
        });
        apiRef.current = api;
        if (onApiReady) onApiReady(api);
      })
      .catch((e) => console.error(e));

    return () => {
      mounted = false;
      if (apiRef.current) apiRef.current.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomName]);

  return (
    <div
      ref={containerRef}
      data-testid="jitsi-container"
      style={{ height, width: "100%", borderRadius: 16, overflow: "hidden", background: "#0a0a0a" }}
    />
  );
}
